






































import {mapActions, mapGetters} from 'vuex';
import {CATEGORIES_DEFAULT_DISPLAY} from '@/store/constants';
import Vue, {PropType} from 'vue';
import {Advert} from '#/Advert';
import {AdvertCategory, CategoryAPI} from '#/Category';

interface ComponentData {
  expendCategories: boolean;
}

export default Vue.extend({
  name: 'ListTemplate',

  data: (): ComponentData => ({
    expendCategories: false,
  }),

  props: {
    advert: {
      type: Object as PropType<Advert>,
      required: true,
    },
    filter: {
      type: [Boolean, Object] as PropType<boolean | CategoryAPI>,
      default: false,
    },
  },

  computed: {
    ...mapGetters([
      'profile',
    ]),
    /**
     * Retourne le nombre de catégories à afficher pour l'annonce
     * par défaut 1
     *
     * @returns {number}
     */
    catShows(): number {
      return this.expendCategories ? this.advert.categories.length : this.defaultCatShows;
    },
    defaultCatShows(): number {
      return this.$vuetify.breakpoint.smAndUp
          ? CATEGORIES_DEFAULT_DISPLAY.desktop
          : CATEGORIES_DEFAULT_DISPLAY.mobile;
    },
    selectableCategoryFilter(): boolean {
      return this.filter && typeof this.filter === 'object' && this.filter.isSelectable;
    },
    hasCategory(): boolean {
      return this.advert.categories && this.advert.categories.length > 0;
    },
    /**
     * If a navigation category filter is active,
     * its calculate a sort method to put first filtered categories     *
     */
    sortFunction(): (a: AdvertCategory, b: AdvertCategory) => 1 | -1| 0 {
      if (this.filter) {
        if ((this.filter as CategoryAPI).isSelectable) {
          return (a, b) => b.id === (this.filter as CategoryAPI).id ? 1 : -1;
        } else {
          let childrenCat: CategoryAPI[] | undefined = (this.filter as CategoryAPI).children;
          if (childrenCat) {
          if (!(this.filter as CategoryAPI).parentCategory ) {
            childrenCat = childrenCat.reduce<CategoryAPI[]>(
                (acc, child) => acc.concat(child.children || []),
                [],
            );
          }

          const childrenCatIds = childrenCat.map(c => c.id);
          return (a, b) => childrenCatIds.includes(b.id)
              ? (childrenCatIds?.includes(a.id) ? 0 : 1)
              : -1;
          }
        }
      }

      return () => 0;
    },
    isPersonalList(): boolean {
      return this.$route.name === 'PersonalAdvertList';
    },
    updatedAt(): string {
      return `Publié le ${(new Date(this.advert.updatedAt)).toLocaleDateString()}`;
    },
  },
  methods: {
    ...mapActions([
      'favoriteUpdate',
    ]),
    /**
     * Met en avant les catégories des annonces correspondantes au filtre de navigation
     */
    sortWithFilter(categories: AdvertCategory[]) {
      const sortedCategories = [...categories];
      if (this.filter) {
        sortedCategories.sort(this.sortFunction);
      }
      return sortedCategories.slice(0, this.catShows);
    },
    /**
     * Limite la longueur d'affichage d'une catégorie à 33 caractères
     */
    displayCategory(categoryName: string): string {
      return categoryName.length > 33
          ? (categoryName.slice(0, 30) + '...')
          : categoryName;
    },
    /**
     * Charge le profil de l'auteur
     */
    onAuthorClick(authorId: number): Promise<void> {
      return new Promise((resolve, reject) => {
        if (!this.isPersonalList && this.profile.id !== authorId) {
          this.$router.push({
            name: 'AuthorDetail',
            params: {authorId: `${authorId}`},
          })
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
        }

        resolve();
      });
    },
    /**
     * Charge les annonces filtrées sur la catégorie sélectionnée
     * si ce n'est pas déjà le filtre courant
     *
     * @param {AdvertCategory} selectedCategory
     */
    onCategoryFilter(selectedCategory: AdvertCategory): Promise<void> {
      return new Promise((resolve, reject) => {
        if (selectedCategory.id !== parseInt(this.$route.query.category as string)) {
          this.$router.push({
            name: 'AdvertList',
            query: {category: `${selectedCategory.id}`},
          })
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
        }
        resolve();
      });
    },
    /**
     * Affiche ou masque les catégories au-delà de la première
     */
    toggleExpend(): void {
      this.expendCategories = !this.expendCategories;
    },
    /**
     * Marque l'annonce comme favorite ou l'annonce est retirée des favorites
     */
    favoriteToggle(): void {
      this.favoriteUpdate(this.advert);
    },
  },
});
